// extracted by mini-css-extract-plugin
export var textInput = "_ly-0";